import React from 'react';

interface RawHtmlProps {
    rawHtmlBlock: string;
}
const RawHTMLModule = ({ rawHtmlBlock }: RawHtmlProps) => (
    <div
        className="html_content"
        dangerouslySetInnerHTML={{ __html: rawHtmlBlock }}
    />
);
export default RawHTMLModule;
